import React, { useState, Children } from 'react';
import { motion } from 'framer-motion';
import { JourneyTimeline } from './JourneyTimeline';
import { Monitor, MousePointerClick, GitBranch, MessageCircle } from 'lucide-react';
const container = {
  hidden: {
    opacity: 0
  },
  show: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1
    }
  }
};
const item = {
  hidden: {
    opacity: 0,
    x: -20
  },
  show: {
    opacity: 1,
    x: 0
  }
};
export function SlideAisleToBooth() {
  const [imgError1, setImgError1] = useState(false);
  const [imgError2, setImgError2] = useState(false);
  const [imgError3, setImgError3] = useState(false);
  return <div className="h-full w-full bg-[#FDF8F8] text-[#2D2926] p-8 md:p-12 flex flex-col" data-id="element-12">
      <JourneyTimeline currentStage={3} data-id="element-13" />

      <motion.div initial={{
      opacity: 0,
      y: 10
    }} animate={{
      opacity: 1,
      y: 0
    }} className="mb-6 border-l-4 border-[#FF6B6B] pl-6" data-id="element-14">
        <div className="flex items-center gap-3 mb-2" data-id="element-15">
          <span className="text-4xl" data-id="element-16">🚪</span>
          <h2 className="text-3xl font-bold text-[#2D2926]" data-id="element-17">
            Aisle to Booth Conversion
          </h2>
        </div>
        <p className="text-xl text-[#FF6B6B] font-medium" data-id="element-18">
          Goal: Nudge curiosity into real engagement
        </p>
      </motion.div>

      <div className="flex-1 grid grid-cols-1 md:grid-cols-[1fr_1fr] gap-6 min-h-0" data-id="element-19">
        <div className="flex flex-col gap-5 overflow-auto" data-id="element-20">
          <motion.div className="bg-white p-5 rounded-xl shadow-sm border border-gray-100" variants={container} initial="hidden" animate="show" data-id="element-21">
            <h3 className="text-lg font-bold text-[#2D2926] mb-4 flex items-center gap-2" data-id="element-22">
              <span className="w-8 h-1 bg-[#FF6B6B] rounded-full" data-id="element-23"></span>
              Tactics
            </h3>
            <ul className="space-y-3" data-id="element-24">
              <motion.li variants={item} className="flex items-start gap-3" data-id="element-25">
                <Monitor className="w-5 h-5 text-[#FF6B6B] mt-0.5 shrink-0" data-id="element-26" />
                <span className="text-gray-700 text-sm" data-id="element-27">
                  Stationary iPads in private setup for self-guided exploration
                </span>
              </motion.li>
              <motion.li variants={item} className="flex items-start gap-3" data-id="element-28">
                <MousePointerClick className="w-5 h-5 text-[#FF6B6B] mt-0.5 shrink-0" data-id="element-29" />
                <span className="text-gray-700 text-sm" data-id="element-30">
                  Large screens or touchscreen walls: product journeys on
                  display
                </span>
              </motion.li>
              <motion.li variants={item} className="flex items-start gap-3" data-id="element-31">
                <GitBranch className="w-5 h-5 text-[#FF6B6B] mt-0.5 shrink-0" data-id="element-32" />
                <span className="text-gray-700 text-sm" data-id="element-33">
                  Engaging product walkthrough Snaks™ — tailored per interest
                </span>
              </motion.li>
              <motion.li variants={item} className="flex items-start gap-3" data-id="element-34">
                <MessageCircle className="w-5 h-5 text-[#FF6B6B] mt-0.5 shrink-0" data-id="element-35" />
                <span className="text-gray-700 text-sm" data-id="element-36">
                  Ice breaker for sales reps actively working the aisles
                </span>
              </motion.li>
            </ul>
          </motion.div>

          <motion.div className="bg-[#FF6B6B]/5 p-5 rounded-xl border border-[#FF6B6B]/10" variants={container} initial="hidden" animate="show" data-id="element-37">
            <h3 className="text-lg font-bold text-[#2D2926] mb-4 flex items-center gap-2" data-id="element-38">
              <span className="w-8 h-1 bg-[#FF6B6B] rounded-full" data-id="element-39"></span>
              Snakker™ Features
            </h3>
            <ul className="space-y-3" data-id="element-40">
              <motion.li variants={item} className="flex items-start gap-3" data-id="element-41">
                <div className="w-2 h-2 rounded-full bg-[#FF6B6B] mt-1.5 shrink-0" data-id="element-42" />
                <span className="text-gray-700 text-sm" data-id="element-43">
                  <strong className="text-[#2D2926]" data-id="element-44">Menu Cue™</strong> for
                  "Choose Your Topic"
                </span>
              </motion.li>
              <motion.li variants={item} className="flex items-start gap-3" data-id="element-45">
                <div className="w-2 h-2 rounded-full bg-[#FF6B6B] mt-1.5 shrink-0" data-id="element-46" />
                <span className="text-gray-700 text-sm" data-id="element-47">
                  Branching with{' '}
                  <strong className="text-[#2D2926]" data-id="element-48">Splits</strong> →
                  personalize depth
                </span>
              </motion.li>
              <motion.li variants={item} className="flex items-start gap-3" data-id="element-49">
                <div className="w-2 h-2 rounded-full bg-[#FF6B6B] mt-1.5 shrink-0" data-id="element-50" />
                <span className="text-gray-700 text-sm" data-id="element-51">
                  Use of{' '}
                  <strong className="text-[#2D2926]" data-id="element-52">Feedback Cues</strong> to
                  spark reflection or discussion
                </span>
              </motion.li>
            </ul>
          </motion.div>
        </div>

        <motion.div className="flex flex-col gap-3 items-center justify-center min-h-0" initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.5,
        delay: 0.3
      }} data-id="element-53">
          <div className="flex flex-col items-center w-full min-h-0" data-id="element-54">
            <a href="https://player.snakker.io/review/9Zrnky3yiOy6anlTc_2D" target="_blank" rel="noopener noreferrer" className="rounded-xl overflow-hidden shadow-lg border border-gray-200 bg-gray-100 max-h-[42vh] w-full block transition-shadow hover:shadow-xl hover:border-[#FF6B6B]/40" data-id="element-55">
              {imgError1 ? <div className="flex flex-col items-center justify-center w-full h-32 text-gray-400 p-4" data-id="element-56">
                  <Monitor className="w-8 h-8 mb-1 text-[#FF6B6B]/40" data-id="element-57" />
                  <p className="text-[10px]" data-id="element-58">Image not available</p>
                </div> : <img src="https://cdn.magicpatterns.com/uploads/jtmDZhu5YvVkqSvWyA7DSo/Screenshot_2026-02-11_at_19.08.09.png" alt="Takeda Focus Areas — disease area selection Snak™" className="w-full h-full object-contain" onError={() => setImgError1(true)} data-id="element-59" />}
            </a>
            <p className="mt-1 text-[9px] text-[#E60012] italic text-center" data-id="element-60">
              Focus area selection —{' '}
              <a href="https://player.snakker.io/review/9Zrnky3yiOy6anlTc_2D" target="_blank" rel="noopener noreferrer" className="underline text-[#2D2926]" data-id="element-61">
                click to explore
              </a>
            </p>
          </div>

          <div className="flex gap-3 min-h-0 w-full" data-id="element-62">
            <div className="flex flex-col items-center flex-1 min-w-0" data-id="element-63">
              <div className="rounded-xl overflow-hidden shadow-lg border border-gray-200 bg-gray-100 max-h-[22vh]" data-id="element-64">
                {imgError2 ? <div className="flex flex-col items-center justify-center w-full h-24 text-gray-400 p-4" data-id="element-65">
                    <Monitor className="w-8 h-8 mb-1 text-[#FF6B6B]/40" data-id="element-66" />
                    <p className="text-[10px]" data-id="element-67">Image not available</p>
                  </div> : <img src="https://cdn.magicpatterns.com/uploads/8zbPoGeL8TMu9dqeqAr2Hr/Screenshot_2026-02-11_at_18.52.54.png" alt="Product deep-dive Snak™" className="w-full h-full object-contain" onError={() => setImgError2(true)} data-id="element-68" />}
              </div>
              <p className="mt-1 text-[9px] text-[#E60012] italic text-center" data-id="element-69">
                Product deep-dive Snak™
              </p>
            </div>

            <div className="flex flex-col items-center flex-1 min-w-0" data-id="element-70">
              <div className="rounded-xl overflow-hidden shadow-lg border border-gray-200 bg-gray-100 max-h-[22vh]" data-id="element-71">
                {imgError3 ? <div className="flex flex-col items-center justify-center w-full h-24 text-gray-400 p-4" data-id="element-72">
                    <Monitor className="w-8 h-8 mb-1 text-[#FF6B6B]/40" data-id="element-73" />
                    <p className="text-[10px]" data-id="element-74">Image not available</p>
                  </div> : <img src="https://cdn.magicpatterns.com/uploads/mTj4uGQgJ8dRMCEeUDZvR3/Screenshot_2026-02-12_at_08.09.15.png" alt="TAKHZYRO challenge Snak™" className="w-full h-full object-contain" onError={() => setImgError3(true)} data-id="element-75" />}
              </div>
              <p className="mt-1 text-[9px] text-[#E60012] italic text-center" data-id="element-76">
                Aisle challenge Snak™
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </div>;
}